/* Brilinton header / drawer helper
 * v118.45: shared drawer control plus native mobile-menu predictive search.
 */
(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function getHeaderDrawer() {
    return document.querySelector('header-drawer[data-breakpoint="tablet"]') || document.querySelector('header-drawer');
  }

  function getHamburger() {
    return document.querySelector('#hamburger-button, header-drawer .hamburger');
  }

  function drawerStates() {
    var headerDrawer = getHeaderDrawer();
    var menuDetails = headerDrawer && headerDrawer.querySelector(':scope > details');
    return {
      headerDrawer: headerDrawer,
      menuDetails: menuDetails,
      menuOpen: Boolean(menuDetails && menuDetails.hasAttribute('open')),
      cartDrawer: document.querySelector('cart-drawer'),
      cartOpen: Boolean(document.querySelector('cart-drawer.active')),
      accountDrawer: document.querySelector('my-brilinton-drawer'),
      accountOpen: Boolean(document.querySelector('my-brilinton-drawer.active'))
    };
  }

  function syncHamburger() {
    var hamburger = getHamburger();
    if (!hamburger) return;

    var state = drawerStates();
    var active = state.menuOpen || state.cartOpen || state.accountOpen;
    hamburger.classList.toggle('active', active);
    hamburger.setAttribute('aria-label', state.accountOpen ? 'Close My Brilinton' : (state.cartOpen ? 'Close cart' : (state.menuOpen ? 'Close menu' : 'Menu')));
  }

  function setBodyUnlocked() {
    var state = drawerStates();
    if (state.menuOpen || state.cartOpen || state.accountOpen) return;
    if (window.BrilintonSurfaceManager && window.BrilintonSurfaceManager.top()) return;
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
  }

  function closeMyBrilinton() {
    var accountDrawer = document.querySelector('my-brilinton-drawer.active');
    if (accountDrawer && typeof accountDrawer.close === 'function') accountDrawer.close();
  }

  function closeCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer.active');
    if (cartDrawer && typeof cartDrawer.close === 'function') cartDrawer.close();
  }

  function closeMenuDrawer() {
    var headerDrawer = getHeaderDrawer();
    var details = headerDrawer && headerDrawer.querySelector(':scope > details[open]');
    var summary = details && details.querySelector(':scope > summary');
    if (!headerDrawer || !details || !summary) return;

    if (typeof headerDrawer.closeMenuDrawer === 'function') {
      headerDrawer.closeMenuDrawer(new Event('click'), summary);
    } else {
      summary.click();
    }
  }

  function createHamburgerButton() {
    var headerDrawer = getHeaderDrawer();
    if (!headerDrawer) return;

    var hamburger = getHamburger();
    if (!hamburger) {
      hamburger = document.createElement('div');
      hamburger.id = 'hamburger-button';
      hamburger.className = 'hamburger';
      hamburger.setAttribute('role', 'button');
      hamburger.setAttribute('aria-label', 'Menu');
      hamburger.setAttribute('tabindex', '0');

      ['line1', 'line2', 'line3'].forEach(function (lineClass) {
        var line = document.createElement('span');
        line.classList.add('line', lineClass);
        hamburger.appendChild(line);
      });

      headerDrawer.appendChild(hamburger);
    }

    if (hamburger.dataset.b1DrawerControlBound === 'true') return;
    hamburger.dataset.b1DrawerControlBound = 'true';

    function activateClick() {
      var state = drawerStates();

      if (state.accountOpen) {
        closeMyBrilinton();
        window.setTimeout(syncHamburger, 20);
        return;
      }

      if (state.cartOpen) {
        closeCartDrawer();
        window.setTimeout(function () {
          syncHamburger();
          setBodyUnlocked();
        }, 20);
        return;
      }

      if (state.menuOpen) {
        closeMenuDrawer();
        window.setTimeout(function () {
          syncHamburger();
          setBodyUnlocked();
        }, 20);
        return;
      }

      var summary = state.menuDetails && state.menuDetails.querySelector(':scope > summary');
      if (summary) summary.click();
      window.setTimeout(syncHamburger, 20);
    }

    hamburger.addEventListener('click', activateClick);
    hamburger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        activateClick();
      }
    });

    var state = drawerStates();
    if (state.cartDrawer) {
      new MutationObserver(function () {
        if (!window.BrilintonSurfaceManager && state.cartDrawer.classList.contains('active')) {
          closeMyBrilinton();
          closeMenuDrawer();
        }
        syncHamburger();
        setBodyUnlocked();
      }).observe(state.cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    if (state.accountDrawer) {
      new MutationObserver(function () {
        syncHamburger();
        setBodyUnlocked();
      }).observe(state.accountDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    if (state.menuDetails) {
      state.menuDetails.addEventListener('toggle', function () {
        syncHamburger();
        setBodyUnlocked();
      });
    }

    syncHamburger();
  }

  function bindDrawerMutualExclusion() {
    var headerDrawer = getHeaderDrawer();
    var summary = headerDrawer && headerDrawer.querySelector(':scope > details > summary');
    if (summary && summary.dataset.b1MutualExclusionBound !== 'true') {
      summary.dataset.b1MutualExclusionBound = 'true';
      summary.addEventListener('click', function () {
        if (window.BrilintonSurfaceManager) return;
        var opening = !summary.closest('details').hasAttribute('open');
        if (!opening) return;
        closeMyBrilinton();
        closeCartDrawer();
      });
    }
  }

  function bindCartIcon() {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon || cartIcon.dataset.b1HeaderHelperBound === 'true') return;
    cartIcon.dataset.b1HeaderHelperBound = 'true';

    cartIcon.addEventListener('click', function () {
      if (!window.BrilintonSurfaceManager) {
        closeMyBrilinton();
        closeMenuDrawer();
      }
      window.setTimeout(syncHamburger, 20);
    });
  }

  function bindSurfaceManagerSync() {
    if (!window.BrilintonSurfaceManager || document.documentElement.dataset.b1SurfaceManagerHeaderSync === 'true') return;
    document.documentElement.dataset.b1SurfaceManagerHeaderSync = 'true';
    document.addEventListener('brilinton:surface-open', function () { window.setTimeout(syncHamburger, 0); });
    document.addEventListener('brilinton:surface-close', function () { window.setTimeout(syncHamburger, 0); });
  }

  function bindSubmenuAutoClose() {
    document.querySelectorAll('.menu-drawer__inner-submenu').forEach(function (submenu) {
      if (submenu.dataset.b1SubmenuBound === 'true') return;
      submenu.dataset.b1SubmenuBound = 'true';

      submenu.addEventListener('click', function (event) {
        var clickedDetails = event.target.closest && event.target.closest('details');
        if (!clickedDetails) return;

        submenu.querySelectorAll('details').forEach(function (details) {
          if (details !== clickedDetails) details.removeAttribute('open');
        });
      });
    });
  }

  function mobileSearchContext(node) {
    var wrapper = node && node.closest ? node.closest('[data-mobile-menu-search]') : null;
    var headerDrawer = wrapper && wrapper.__b1HeaderDrawer
      ? wrapper.__b1HeaderDrawer
      : (node && node.closest ? node.closest('header-drawer') : getHeaderDrawer());

    if (!headerDrawer) return null;
    if (!wrapper) wrapper = headerDrawer.querySelector('[data-mobile-menu-search]');
    if (!wrapper) return null;

    wrapper.__b1HeaderDrawer = headerDrawer;
    var input = wrapper.querySelector('[data-mobile-search-input]');
    var back = wrapper.querySelector('[data-mobile-search-back]');
    var mainDetails = headerDrawer.querySelector(':scope > details');
    var predictiveSearch = wrapper.querySelector('predictive-search');

    if (!input || !back || !mainDetails) return null;
    return {
      headerDrawer: headerDrawer,
      wrapper: wrapper,
      input: input,
      back: back,
      mainDetails: mainDetails,
      predictiveSearch: predictiveSearch
    };
  }

  function updateMobileSearchGeometry(context) {
    if (!context || !window.matchMedia('(max-width: 749px)').matches) return;
    var wrapper = context.headerDrawer.closest('.header-wrapper') || document.querySelector('.header-wrapper');
    if (!wrapper) return;

    var rect = wrapper.getBoundingClientRect();
    context.wrapper.style.setProperty('--mobile-search-top', Math.max(0, Math.round(rect.top)) + 'px');
    context.wrapper.style.setProperty('--mobile-search-header-height', Math.max(1, Math.round(rect.height)) + 'px');
  }

  function clearMobilePredictiveSearch(context) {
    if (!context) return;
    context.input.value = '';
    context.wrapper.classList.remove('has-query');
    var reset = context.wrapper.querySelector('button[type="reset"]');
    if (reset) reset.classList.add('hidden');
    if (context.predictiveSearch && typeof context.predictiveSearch.close === 'function') {
      context.predictiveSearch.close(true);
    }
  }

  function openMobileSearch(context) {
    if (!context || !window.matchMedia('(max-width: 749px)').matches) return;
    if (context.headerDrawer.classList.contains('mobile-search-active')) return;

    closeMyBrilinton();
    closeCartDrawer();
    updateMobileSearchGeometry(context);

    if (!context.wrapper.__b1SearchPlaceholder) {
      context.wrapper.__b1SearchPlaceholder = document.createComment('Brilinton mobile search');
      context.wrapper.parentNode.insertBefore(context.wrapper.__b1SearchPlaceholder, context.wrapper);
    }

    context.headerDrawer.classList.add('mobile-search-active');
    context.wrapper.classList.add('is-mobile-search-portal');
    document.body.appendChild(context.wrapper);
    context.back.setAttribute('aria-expanded', 'true');

    window.setTimeout(function () {
      context.input.focus({ preventScroll: true });
    }, 20);
  }

  function closeMobileSearch(context, options) {
    if (!context) return;
    var shouldFocusInput = Boolean(options && options.focusInput);

    context.headerDrawer.classList.remove('mobile-search-active');
    context.back.setAttribute('aria-expanded', 'false');
    clearMobilePredictiveSearch(context);
    context.wrapper.classList.remove('is-mobile-search-portal');
    context.wrapper.style.removeProperty('--mobile-search-top');
    context.wrapper.style.removeProperty('--mobile-search-header-height');

    var placeholder = context.wrapper.__b1SearchPlaceholder;
    if (placeholder && placeholder.parentNode) {
      placeholder.parentNode.insertBefore(context.wrapper, placeholder);
      placeholder.remove();
    }
    context.wrapper.__b1SearchPlaceholder = null;

    if (shouldFocusInput && context.mainDetails.hasAttribute('open')) {
      window.setTimeout(function () { context.input.focus(); }, 20);
    }
  }

  function bindMobileMenuSearch() {
    if (document.documentElement.dataset.b1MobileSearchBound === 'true') return;
    document.documentElement.dataset.b1MobileSearchBound = 'true';

    document.addEventListener('focusin', function (event) {
      if (!(event.target instanceof Element) || !event.target.matches('[data-mobile-search-input]')) return;
      var context = mobileSearchContext(event.target);
      if (!context) return;
      openMobileSearch(context);
    });

    document.addEventListener('pointerdown', function (event) {
      if (!(event.target instanceof Element)) return;
      var field = event.target.closest('[data-mobile-menu-search] .field');
      if (!field) return;
      var context = mobileSearchContext(field);
      if (!context) return;
      openMobileSearch(context);
    }, { passive: true });

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var back = event.target.closest('[data-mobile-search-back]');
      if (!back) return;
      var context = mobileSearchContext(back);
      if (!context) return;
      event.preventDefault();
      event.stopPropagation();
      closeMobileSearch(context, { focusInput: false });
    }, true);

    document.addEventListener('input', function (event) {
      if (!(event.target instanceof Element) || !event.target.matches('[data-mobile-search-input]')) return;
      var context = mobileSearchContext(event.target);
      if (!context) return;
      context.wrapper.classList.toggle('has-query', context.input.value.trim().length > 0);
    }, true);

    document.addEventListener('keyup', function (event) {
      if (event.code !== 'Escape') return;
      var activeDrawer = document.querySelector('header-drawer.mobile-search-active');
      if (!activeDrawer) return;
      var context = mobileSearchContext(activeDrawer);
      if (!context) return;
      event.preventDefault();
      event.stopPropagation();
      closeMobileSearch(context, { focusInput: false });
    }, true);

    document.addEventListener('toggle', function (event) {
      if (!(event.target instanceof Element) || !event.target.matches('header-drawer > details')) return;
      if (event.target.hasAttribute('open')) return;
      var context = mobileSearchContext(event.target);
      if (context && context.headerDrawer.classList.contains('mobile-search-active')) {
        closeMobileSearch(context, { focusInput: false });
      }
    }, true);

    window.addEventListener('resize', function () {
      document.querySelectorAll('.mobile_search_wrapper.is-mobile-search-portal').forEach(function (wrapper) {
        var context = mobileSearchContext(wrapper);
        if (!context) return;
        if (window.matchMedia('(max-width: 749px)').matches) {
          updateMobileSearchGeometry(context);
        } else {
          closeMobileSearch(context, { focusInput: false });
        }
      });
    }, { passive: true });
  }

  function openDesktopHeaderMenus() {
    document.querySelectorAll('header-menu > details').forEach(function (detail) {
      detail.setAttribute('open', '');
    });
  }

  ready(function () {
    createHamburgerButton();
    bindDrawerMutualExclusion();
    bindCartIcon();
    bindSurfaceManagerSync();
    bindSubmenuAutoClose();
    bindMobileMenuSearch();
    openDesktopHeaderMenus();

    window.addEventListener('brilinton:layout-refresh', function () {
      syncHamburger();
      openDesktopHeaderMenus();
      document.querySelectorAll('.mobile_search_wrapper.is-mobile-search-portal').forEach(function (wrapper) {
        var context = mobileSearchContext(wrapper);
        if (context) updateMobileSearchGeometry(context);
      });
    });
  });
})();
